import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import PDPSwiperMobile from './pdp-swiper-mobile/PDPSwiperMobile.vue';
import PDPSwiperDesktop from './pdp-swiper-desktop/PDPSwiperDesktop.vue';
import useBreakpoints from '@/core/responsive/breakpoints/breakpoint.mixin';


export default /*#__PURE__*/_defineComponent({
  __name: 'PDPSwiper',
  props: {
    images: { default: () => [] },
    altTextOverride: { default: undefined },
    zoomBackgroundClass: { default: 'u-bg-grey-4' }
  },
  setup(__props: any) {


const breakpointIsActive = useBreakpoints();

const layout = computed<'full'|'mobile'>(() => {
    return breakpointIsActive.value.large ? 'full' : 'mobile';
});


return { __sfc: true,breakpointIsActive, layout, PDPSwiperMobile, PDPSwiperDesktop }
}

})